import { capitalizeFirst } from '../../utils';
export var toastPositions = [
    { id: 'bottom', value: 'bottom', label: 'Bottom' },
    { id: 'top', value: 'top', label: 'Top' },
];
export var tabSettingOptions = [
    {
        id: '-1',
        label: 'Auto',
    },
    {
        id: '0',
        label: "Only show 'More' icon to select an item",
    },
    {
        id: '1',
        label: '1',
    },
    {
        id: '2',
        label: '2',
    },
    {
        id: '3',
        label: '3',
    },
    {
        id: '4',
        label: '4',
    },
    {
        id: '5',
        label: '5',
    },
];
var gridSettingOptions = [
    {
        id: '-1',
        label: 'Auto',
    },
    {
        id: '1',
        label: '1',
    },
    {
        id: '2',
        label: '2',
    },
    {
        id: '3',
        label: '3',
    },
    {
        id: '4',
        label: '4',
    },
    {
        id: '5',
        label: '5',
    },
];
export var loadingState = {
    name: 'loading',
    type: 'boolean',
    key: 'loading',
    label: 'Loading',
};
export var pushPlatforms = ['ios', 'android', 'web'].map(function (platform) { return ({
    id: platform,
    label: platform,
    value: platform,
}); });
export var tabSettingsFormConfig = function (settings) { return ({
    data: settings,
    config: [
        {
            name: 'maxItems',
            label: 'Maximum number of items shown',
            type: 'radio',
            required: true,
            disabled: false,
            options: tabSettingOptions,
        },
    ],
}); };
export var gridSettingsFormConfig = function (settings) { return ({
    data: settings,
    config: [
        {
            name: 'maxColumns',
            label: 'Maximum number of columns shown',
            type: 'radio',
            required: true,
            disabled: false,
            options: gridSettingOptions,
        },
    ],
}); };
export var textAlignOptions = ['center', 'left', 'right'].map(function (alignment) { return ({
    value: alignment,
    label: capitalizeFirst(alignment),
}); });
export var navigationTypeOptions = [
    { value: 'drawer', label: 'Drawer' },
    // { value: 'grid', label: 'Grid' }, //TODO: add same styling as tab bar in RNAPP
    { value: 'tab', label: 'Bottom tab' },
    // { value: 'dropdown', label: 'Dropdown' }, //TODO: fix horrible styling in RNAPP
];
